{
  "paymentInformation": "Maksutiedot",
  "paymentReferences": "Viitteet ja tilinumerot",
  "paymentHistory": "Maksuhistoria",
  "currentMonth": "Kuluva kuukausi",
  "invoices": "Laskut",
  "itemisation": "Laskuerittely",
  "payer": "Maksaja",
  "dueDate": "Eräpäivä",
  "sum": "Summa",
  "sumTotal": "Yhteensä",
  "remittances": "Maksut",
  "refund": "Palautus",
  "transfer": "Siirto",
  "withheldFrom": {
    "securityDeposit": "Pidätys vakuudesta",
    "depositVoucher": "Pidätys maksusitoumuksesta",
    "rooFee": "Pidätys asumisoikeusmaksusta"
  },
  "paidDate": "Maksettu",
  "noTargets": "Ei laskurivejä",
  "creditNote": "Hyvitys",
  "noRemittances": "Ei maksuja",
  "arrearTotal": "Maksettava yhteensä",
  "advanceTotal": "Ennakkoa yhteensä",
  "arrearTotalForMonth": "Maksettavaa {{month}}",
  "advanceTotalForMonth": "Ennakkoa {{month}}",
  "neutralTotal": "Yhteensä",
  "saldo": "Saldo",
  "paymentTypeCategory": {
    "chargesForUtilities": "Käyttökorvaus",
    "rent": "Vuokra",
    "residenceCharge": "Käyttövastike",
    "rightOfOccupancyDeposit": "Asumisoikeusmaksu",
    "securityDeposit": "Vakuusmaksu",
    "interest": "Korko",
    "generic": "Yleinen",
    "rightOfOccupancyNewDevelopmentDeposit": "Uudisrakentamisen ASO-maksu"
  },
  "paymentsBeneficiary": "Saaja",
  "referenceNumber": "Laskujen viitenumero",
  "noAccountData": "Tilitiedot puuttuvat",
  "rightOfOccupancyFee": {
    "tab": "Asumisoikeusmaksu",
    "preliminaryNotice": "Tämä on alustava laskelma. Lopullinen asumisoikeusmaksu lasketaan, kun asumisoikeus päättyy.",
    "currentValueTitle": "Asumisoikeusmaksun nykyarvo",
    "currentValueIndexInfo": "Laskelma perustuu rakennuskustannusindeksiin {{month}}. Arvo päivittyy, kun rakennuskustannusindeksi tai perusparannuslisät muuttuvat.",
    "originalValue": "Alkuperäinen asumisoikeusmaksu",
    "indexAdjustment": "Indeksikorotus",
    "improvementValue": "Perusparannuslisä",
    "currentValue": "Nykyarvo",
    "paidTitle": "Maksettu asumisoikeusmaksu",
    "paidAmount": "Maksettu määrä",
    "paidDate": "Maksupäivä",
    "notPaidWarning": "Asumisoikeusmaksua ei ole vielä maksettu",
    "payableTitle": "Maksettava asumisoikeusmaksu",
    "amountPayable": "Maksettava määrä",
    "remainingPayable": "Vielä maksettava",
    "goToPaymentReferences": "Siirry maksuviitteisiin",
    "finalCalculationNotice": "Asumisoikeusmaksun loppulaskelma toimitetaan erikseen.",
    "valueAtTerminationTitle": "Asumisoikeusmaksu sopimuksen päättyessä",
    "valueAtTerminationIndexInfo": "Laskelma perustuu rakennuskustannusindeksiin {{month}}, joka oli voimassa sopimuksen päättyessä.",
    "valueAtTermination": "Arvo sopimuksen päättyessä",
    "withholdingsAndRefundsTitle": "Pidätykset ja palautukset",
    "withholding": "Pidätys: {{description}}",
    "refund": "Palautus {{date}}",
    "remainingValue": "Jäljellä oleva arvo"
  },
  "errors": {
    "failedToLoadPaymentInfo": "Maksutietojen lataaminen epäonnistui",
    "failedToLoadPaymentHistory": "Maksuhistorian lataaminen epäonnistui",
    "paymentsAccessDenied": "Sinulla ei ole riittäviä oikeuksia nähdä tämän sopimuksen maksutietoja."
  },
  "bankAccountLabel": "{{category}}, {{bankName}}"
}
